<template>
  <div class="animated fadeIn employee-list">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4>Danh sách nhân viên</h4>
          </div>
          <div class="text-right d-flex justify-content-end employee-actions">
            <div class="customs">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-radius-10 btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
              <el-button
                v-if="mData.dataDefault.listFeature.includes('FT103')"
                @click="fn_handle('create')"
                class="pl-2 btn-default"
                type="primary"
                round
              >
                Thêm mới
                <i class="icon-Edit"></i>
              </el-button>
              <el-button
                v-if="mData.dataDefault.listFeature.includes('FT103')"
                type="primary"
                class="btn-default"
                round
                @click="mData.dialogFormImportNhanVien = true"
              >
                Nhập dữ liệu
                <i class="icon-Import"></i>
              </el-button>
              <el-button
                v-if="mData.dataDefault.listFeature.includes('FT105')"
                type="primary"
                class="btn-default"
                round
                @click="exportDataEmployee"
              >
                Xuất dữ liệu
                <i class="icon-Export"></i>
              </el-button>
              <div class="switch-view">
                <div class="list__view">
                  <div
                    :class="{
                      'grid-view view': true,
                      'active-view': currentView == 'card'
                    }"
                    title="Dạng Card"
                    @click="changeView('card')"
                  >
                    <i class="fas fa-th fa-lg"></i>
                  </div>
                  <div
                    :class="{
                      'list-view view': true,
                      'active-view': currentView == 'table'
                    }"
                    title="Dạng Bảng"
                    @click="changeView('table')"
                  >
                    <i class="fas fa-list fa-lg"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <b-card>
                <el-form
                  ref="myForm"
                  label-position="left"
                  @submit.native.prevent
                  label-width="130px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row class="row-flex">
                    <div class="flex-width">
                      <el-form-item label="Công ty: " prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.company_id"
                          @change="fn_handleEmployeeCompanySearchChange"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listCompany"
                            :key="item.id"
                            :label="item.name.name_vi || item.name.abbreviation_name || item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Chi nhánh: " prop="">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'job_info.branch_id'
                            ]
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChiNhanh"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Phòng ban: " prop="">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'job_info.department_id'
                            ]
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listPhongBan"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Chức vụ: " prop="">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'job_info.position_id'
                            ]
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChucVu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Giới tính: " prop="">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'administrative_info.gender'
                            ]
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listGioiTinh"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Trạng thái: " prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.status"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThai"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Bảo hiểm: " prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['salary.insurance_salary']"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listYesNo"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Thâm niên: " prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['start_work_date']"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listSenioritys"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Loại hợp đồng: " prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['job_info.contract_type_id']"
                          @change="changeContractType"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listHopDong"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="flex-width">
                      <el-form-item label="Hợp đồng: " prop=""
                        v-if="
                          mData.tableRules.dataSearch.value['job_info.contract_type_id'] != '' &&
                          mData.tableRules.dataSearch.value['job_info.contract_type_id'] != undefined &&
                          mData.tableRules.dataSearch.value['job_info.contract_type_id'] != null
                        "
                      >
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['start_date*end_date']"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listValidityPeriod"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </b-row>
                  <b-row class="row-flex">
                    <div class="input-condition">
                      <el-form-item label="Điều kiện: " prop="">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.condition"
                          placeholder="Nhập Mã nhân viên, Họ và tên, Số điện thoại, Số CMND/CCCD, Email"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="button__search">
                      <el-button
                        round
                        native-type="submit"
                        class="btn-default btn-search"
                        @click="fn_tableSearch()"
                      >
                        Tìm kiếm
                      </el-button>
                    </div>
                  </b-row>
                  <el-form-item class="text-center mb-0">

                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div v-if="currentView == 'table'" class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              @selection-change="fn_tableSelectionChange"
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              max-height="500"
              :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
            >
              <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_no"
                label="Mã chấm công"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="administrative_info.name.first_name"
                label="Họ và tên"
                min-width="200"
              >
                <template slot-scope="scope">
                  <span
                    class="full_name"
                    @click="mData.dataDefault.listFeature.includes('FT104') ? fn_handle('update', scope.row.id) : doNothing()"
                  >
                    {{scope.row.administrative_info.name.full_name}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="chuc_vu"
                label="Chức vụ"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="phong_ban"
                label="Phòng ban"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="chi_nhanh"
                label="Chi nhánh"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                prop="administrative_info.phone_number"
                label="SĐT"
                min-width="105"
              ></el-table-column>
              <el-table-column
                prop="administrative_info.email"
                label="Email"
                min-width="167"
              ></el-table-column>
              <el-table-column
                prop="status"
                label="Trạng thái"
                min-width="110"
              ></el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="120px"
                v-if="mData.dataDefault.listFeature.includes('FT102') && mData.dataDefault.listFeature.includes('FT104')"
              >
                <template slot-scope="scope">
                  <!-- <el-button
                    v-if="mData.dataDefault.listFeature.includes('FT102')"
                    size="mini"
                    round
                    plain
                    @click="fn_handle('detail',scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button> -->
                  <el-button
                    v-if="mData.dataDefault.listFeature.includes('FT104')"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('update', scope.row.id)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    v-if="mData.dataDefault.listFeature.includes('FT104')"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('delete', scope.row.id)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fal fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="currentView  == 'card'" class="main-body-list"
            :style="mData.tableRules.showFormSearch === true ? 'max-height: calc(100vh - 464px);' : 'max-height: calc(100vh - 242px);'"
          >
            <div ref="wrapper">
              <b-row v-if="mData.tableRules.data.length == 0">
                <b-col md="12" class="text-center">
                  <p class="table__empty-text">Không có dữ liệu</p>
                </b-col>
              </b-row>
              <b-row v-if="mData.tableRules.data.length > 0">
                <b-col
                  :xl="currentXL" lg="6"
                  v-for="(item,index) in mData.tableRules.data"
                  :key="index"
                >
                  <div class="e-avatar">
                    <el-image
                      :src="
                        item.avataUrl ? item.avataUrl : 'img/demo.png'"
                      fit="cover"
                      alt="Avatar"
                    ></el-image>
                  </div>
                  <el-card class="box-card">
                    <div class="icon-haveDraff" v-if="checkHaveDraff(item.id)" title="Cần duyệt thông tin" @click="fn_handle('approve',item.id)">
                      <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="text-center employee">
                      <p
                        :title="
                          item.administrative_info &&
                          item.administrative_info.name &&
                          item.administrative_info.name.full_name ?
                          item.administrative_info.name.full_name : ''
                        "
                        class="e-name"
                      >
                        {{
                          item.administrative_info &&
                          item.administrative_info.name &&
                          item.administrative_info.name.full_name ?
                          item.administrative_info.name.full_name : ""
                        }}
                      </p>
                      <p
                        :title="
                          item.chuc_vu &&
                          item.chuc_vu.trim() != '' ?
                          item.chuc_vu : '.....'
                        "
                        class="e-position"
                      >
                        {{
                          item.chuc_vu &&
                          item.chuc_vu.trim() != "" ?
                          item.chuc_vu : "....."
                        }}
                      </p>
                    </div>
                    <div class="detail-infomation">
                      <p class="e-department">
                        <i class="icon-Department"></i>
                        <span>
                          {{item.phong_ban}}
                        </span>
                      </p>
                      <p class="e-branch">
                        <i class="icon-Map"></i>
                        <span>
                          {{item.chi_nhanh}}
                        </span>
                      </p>
                      <p class="e-email">
                        <i class="icon-Mail"></i>
                        <span>
                          {{
                            item.administrative_info &&
                            item.administrative_info.email ?
                            item.administrative_info.email : ""
                          }}
                        </span>
                      </p>
                      <p class="e-phone">
                        <i class="icon-Call"></i>
                        <span>
                          {{
                            item.administrative_info &&
                            item.administrative_info.phone_number ?
                            item.administrative_info.phone_number : ""
                          }}
                        </span>
                      </p>
                    </div>
                    <div class="handle-action">
                      <div
                        class="btn-default el-button__handle"
                        @click="fn_handle('update',item.id)"
                        v-if="mData.dataDefault.listFeature.includes('FT102') || mData.dataDefault.listFeature.includes('FT104')"
                      >
                        <span>
                          <i class="icon-Eye"></i>
                          Xem
                        </span>
                      </div>
                      <div
                        :class="item.status == 'Đã nghỉ việc' ? 'status off-work' : 'status work'"
                      >
                        <span>
                          {{
                            item.status ? item.status : ""
                          }}
                        </span>
                      </div>
                    </div>
                  </el-card>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right  mt-2">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurentChange"
              @prev-click="handlePrevClick"
              @next-click="handleNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="this.mData.tableRules.total"
              background
              :pager-count="5"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- dialog import -->
    <el-dialog
      class="import__employee"
      title="Nhập dữ liệu nhân viên"
      :visible.sync="mData.dialogFormImportNhanVien"
      :before-close="closeImport"
      top="20px"
      :width="mData.dataDefault.dataExcel.length > 0 ? '95%' : '500px'"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-loading="mData.importing"
    >
      <div class="mt-2" style="margin: 0 auto;max-width: 360px;">
        <el-form>
          <el-form-item prop="">
            <el-upload
              drag
              action
              :auto-upload="false"
              :accept="mData.fileUploadOption.File.accept"
              :on-change="fn_uploadChangeFile"
              :on-remove="fn_uploadRemoveFile"
              :file-list="mData.fileUploadOption.File.fileList"
              :multiple="false"
            >
              <div>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Kéo file vào đây hoặc <em>bấm để tải lên</em>
                </div>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="text-right d-flex at-center jc-end">
        <div v-if="mData.dataDefault.dataExcel.length" class="import-summary mr-auto">
          <strong>{{ mData.dataDefault.dataExcel.length }}</strong> dòng dữ liệu
          <span v-if="mData.dataErrorFECheck.length" class="text-danger">
            - {{ mData.dataErrorFECheck.length }} lỗi
          </span>
        </div>
        <div class="mr-3">
          <span
            class="download__css"
            @click="downloadTemplate"
          >
            Tải template mẫu
          </span>
        </div>
        <el-button
          @click="closeImport"
          round
        >
          Huỷ
        </el-button>
        <el-button
          :disabled="mData.fileUploadOption.File.fileList.length == 0 || mData.haveErrorImport"
          :loading="mData.importing"
          class="btn-default"
          @click="importEmployee"
          round
        >
          Nhập dữ liệu
        </el-button>
      </div>
      <el-table
        v-if="mData.dataDefault.dataExcel.length > 0"
        class="mt-2"
        :data="mData.dataDefault.dataExcel"
        :row-class-name="importRowClassName"
        border
        style="width: 100%"
        max-height="390"
      >
        <el-table-column
          label="STT"
          width="50"
        >
          <template slot-scope="scope">
            <div class="text-center">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="EmployeeNo"
          label="Mã nhân viên"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="LastName"
          label="Họ và tên đệm"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="FirstName"
          label="Tên"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="Gender"
          label="Giới tính"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="PhoneNumber"
          label="Số điện thoại"
          width="130"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Email"
          label="Email"
          min-width="170"
        ></el-table-column>
        <el-table-column
          prop="IdentifyCard"
          label="Số CMND"
          min-width="170"
        ></el-table-column>
        <el-table-column
          label="Ngày sinh"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{formatDateTableExcel(scope.row.Birthday)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="Address"
          label="Địa chỉ"
          min-width="170"
        ></el-table-column>
        <el-table-column
          prop="Account"
          label="Tài khoản"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="ContractTypeCode"
          label="Mã hợp đồng"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="ContractTypeName"
          label="Hợp đồng"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="PositionCode"
          label="Mã chức vụ"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="PositionName"
          label="Chức vụ"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="DepartmentCode"
          label="Mã phòng ban"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="DepartmentName"
          label="Phòng ban"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="BranchCode"
          label="Mã chi nhánh"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="BranchName"
          label="Chi nhánh"
          min-width="180"
        ></el-table-column>
        <el-table-column
          label="Ngày bắt đầu"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{formatDateTableExcel(scope.row.StartDate)}}
          </template>
        </el-table-column>
        <el-table-column
          label="Ngày kết thúc"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{formatDateTableExcel(scope.row.EndDate)}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- dialog lỗi khi validate by Front-End import nhân viên -->
    <el-dialog
      title="Lỗi"
      top="20px"
      :visible.sync="visibleDialogValidateImport"
      border
      width="70%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-table
        class="mt-2"
        :data="mData.dataErrorFECheck"
        border
        style="width: 100%"
        max-height="520"
      >
        <el-table-column
          label="STT"
          width="50"
        >
          <template slot-scope="scope">
            <div class="text-center">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="field"
          label="Trường"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="value"
          label="Giá trị"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="message"
          label="Thông báo"
          min-width="130"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- dialog lỗi khi import  -->
    <el-dialog
      class="import__employee"
      title="Lỗi khi nhập dữ liệu nhân viên"
      :visible.sync="dialogErrorImportNhanVienBE"
      :before-close="closeErrorImportNhanVienBE"
      top="20px"
      width="98%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="text-center mb-3">
        <h6>Có một số bản ghi đang bị lỗi. Vui lòng xem lại và nhập dữ liệu lại !</h6>
      </div>
      <el-table
        class="mt-2 table-error-message"
        :data="mData.dataDefault.listErrorImport"
        border
        style="width: 100%"
        max-height="390"
      >
        <el-table-column
          label="STT"
          width="50"
        >
          <template slot-scope="scope">
            <div class="text-center">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="EmployeeNo"
          label="Mã nhân viên"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="LastName"
          label="Họ và tên đệm"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="FirstName"
          label="Tên"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="Gender"
          label="Giới tính"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="PhoneNumber"
          label="Số điện thoại"
          width="130"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Email"
          label="Email"
          min-width="170"
        ></el-table-column>
        <el-table-column
          prop="Account"
          label="Tài khoản"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="ContractTypeCode"
          label="Mã hợp đồng"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="ContractTypeName"
          label="Hợp đồng"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="PositionCode"
          label="Mã chức vụ"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="PositionName"
          label="Chức vụ"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="DepartmentCode"
          label="Mã phòng ban"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="DepartmentName"
          label="Phòng ban"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="BranchCode"
          label="Mã chi nhánh"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="BranchName"
          label="Chi nhánh"
          min-width="180"
        ></el-table-column>
        <el-table-column
          label="Ngày bắt đầu"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{formatDateTableExcelError(scope.row.StartDate)}}
          </template>
        </el-table-column>
        <el-table-column
          label="Ngày kết thúc"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            {{formatDateTableExcelError(scope.row.EndDate)}}
          </template>
        </el-table-column>
        <el-table-column
          label="Thông báo"
          min-width="220"
        >
          <template slot-scope="scope">
            <div>
              <ul
                style="word-break: break-word;white-space: break-spaces;padding-inline-start: 20px;margin-bottom: 0;"
              >
                <li v-for="(e,i) in scope.row.messages" :key="i">{{e}}</li>
              </ul>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <Loading v-if="loading"/>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import EmployeeModel from "./EmployeeModel";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import CompanyApi from "../../../moduleApi/CompanyApi";
import BranchApi from "../../../moduleApi/BranchApi";
import DepartmentApi from "../../../moduleApi/DepartmentApi";
import PositionApi from "../../../moduleApi/PositionApi";
import ShiftApi from "../../../moduleApi/ShiftApi";
import ContractTypeApi from '../../../moduleApi/ContractTypeApi';
import QualificationApi from '../../../moduleApi/QualificationApi';
import MajorApi from '../../../moduleApi/MajorApi';
import RelationshipApi from '../../../moduleApi/RelationshipApi';
import RankSalaryApi from '../../../moduleApi/RankSalaryApi';
import CoefficientSalaryApi from '../../../moduleApi/CoefficientSalaryApi';
import SubsidiesSalaryTypeApi from '../../../moduleApi/SubsidiesSalaryTypeApi';
import EmployeeDraffApi from "../../../moduleApi/EmployeeDraffApi";
import EmployeeSignatureDraffApi from "../../../moduleApi/EmployeeSignatureDraffApi";
import Loading from "../../../component/Loading";
import * as moment from "moment";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      file1: undefined,
      loading: false,
      imgUrl: ExtensionService.urlImg,
      aLang: LanguageService.lang,
      aExtension: ExtensionService,
      aElement: MethodService.element,
      dataFilter: {},
      visibleDialogValidateImport: false,
      dialogErrorImportNhanVienBE: false,
      totalEmployee: 0,
      viewByTable: undefined,
      currentView: "card",
      currentXL: 3,
      defaultDataLoaded: false,
      defaultDataPromise: null,
      listRenderToken: 0,
      employeeConditionCacheKey: "",
      employeeConditionCacheData: [],
      mData: {
        companyInfo: {},
        dataErrorFECheck: [],
        data: [],
        moduleName: "EmployeeManager", //requied
        dialogFormImportNhanVien: false,
        tableRules: EmployeeModel.tableRules,
        dataDefault: {
          file: "",
          listCompany: [],
          listCompanyAll: [],
          listChiNhanhAll: [],
          listPhongBanAll: [],
          listChucVuAll: [],
          listHopDongAll: [],
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listHopDong: [],
          listTrinhDo: [],
          listChuyenNganh: [],
          listQuanHe: [],
          listBacLuong: [],
          listHeSoLuong: [],
          listTroCap: [],
          listTrangThai: DataService.listTrangThaiLamViec,
          listSenioritys: [
            {
              value: '0-1',
              label: "0-1 năm"
            },
            {
              value: '1-3',
              label: "1-3 năm"
            },
            {
              value: '3-5',
              label: "3-5 năm"
            },
            {
              value: '5-7',
              label: "5-7 năm"
            },
            {
              value: '7-0',
              label: "7+ năm"
            },
          ],
          listGioiTinh: [
            {
              value: '0',
              label: "Nữ"
            },
            {
              value: '1',
              label: "Nam"
            },
            {
              value: '2',
              label: "Khác"
            }
          ],
          listYesNo: [
            {
              value: 'true',
              label: "Không"
            },
            {
              value: 'false',
              label: "Có"
            },
          ],
          listValidityPeriod: [
            {
              value: "validated",
              label: "Còn hiệu lực"
            },
            {
              value: "about_to_expire",
              label: "Sắp hết hạn"
            },
            {
              value: "expired",
              label: "Hết hạn"
            }
          ],
          // list
          listFeature: MethodService.getListFeatures(),
          listShift: [],
          dataExcelHeader: [],
          dataExcelBody: [],
          dataExcel: [],
          listErrorImport: [],
          listEmployeeDraff: [],
          listEmployeeSignatureDraff: [],

        },
        haveErrorImport: false,
        importing: false,
        importErrorRows: [],
        fileUploadOption: {
          File: {
            limit: 1,
            accept: ".xls, .xlsx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      }
    };
  },
  mounted() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        if (width < 1170) {
          this.currentXL = 4;
        } else if(width >= 1170 && width < 1760) {
          this.currentXL = 3;
        }
        else{
          this.currentXL = 2;
        }
      }
    });
    resizeObserver.observe(this.$refs.wrapper);
  },
  methods: {
    fn_normalizeCompanyOptions(source) {
      if (Array.isArray(source)) {
        return source;
      }
      if (source && Array.isArray(source.companies)) {
        return source.companies;
      }
      return [];
    },
    fn_getCompanyTreeScope(companies = [], rootCompanyId) {
      if (!rootCompanyId || !Array.isArray(companies) || companies.length === 0) {
        return [];
      }
      const companyMap = new Map();
      companies.forEach(item => {
        if (item && item.id) {
          companyMap.set(item.id, item);
        }
      });
      const scope = [];
      const visited = new Set();
      const stack = [rootCompanyId];
      while (stack.length > 0) {
        const currentId = stack.pop();
        if (!currentId || visited.has(currentId)) {
          continue;
        }
        visited.add(currentId);
        const currentCompany = companyMap.get(currentId);
        if (currentCompany) {
          scope.push(currentCompany);
        }
        companies.forEach(item => {
          if (item && item.parent_company_id === currentId && !visited.has(item.id)) {
            stack.push(item.id);
          }
        });
      }
      return scope;
    },
    fn_mergeCompanyScope(primaryCompanies = [], fallbackCompanies = []) {
      const companyMap = new Map();
      [
        ...this.fn_normalizeCompanyOptions(primaryCompanies),
        ...this.fn_normalizeCompanyOptions(fallbackCompanies),
      ].forEach(item => {
        if (item && item.id && !companyMap.has(item.id)) {
          companyMap.set(item.id, item);
        }
      });
      return Array.from(companyMap.values());
    },
    fn_getEmployeeSelectedCompanyScopeIds(companyId) {
      const rootCompanyId = companyId || (this.mData.companyInfo && this.mData.companyInfo.id);
      const scopeCompanies = this.fn_getCompanyTreeScope(
        this.mData.dataDefault.listCompany || [],
        rootCompanyId
      );
      return scopeCompanies.map(item => item.id).filter(Boolean);
    },
    fn_filterEmployeePositionOptionsByCompany(selectedCompanyId) {
      const positionOptions = this.mData.dataDefault.listChucVuAll || [];
      if (!selectedCompanyId) {
        return positionOptions;
      }
      return positionOptions.filter((item) => {
        if (!item) return false;
        return (
          item.company_id === selectedCompanyId ||
          item.company_id === "system" ||
          item.company_id === null ||
          item.company_id === undefined ||
          item.company_id === ""
        );
      });
    },
    fn_filterEmployeeContractTypeOptionsByCompany(selectedCompanyId) {
      const contractTypeOptions = this.mData.dataDefault.listHopDongAll || [];
      if (!selectedCompanyId) {
        return contractTypeOptions;
      }
      return contractTypeOptions.filter((item) => {
        if (!item) return false;
        return (
          item.company_id === selectedCompanyId ||
          item.company_id === "system" ||
          item.company_id === null ||
          item.company_id === undefined ||
          item.company_id === ""
        );
      });
    },
    async fn_applyEmployeeCompanyDependentOptions() {
      const selectedCompanyId = this.mData.tableRules.dataSearch.value.company_id;
      const query = { limit: 10000 };
      if (selectedCompanyId) {
        query.filters = `company_id=${selectedCompanyId}`;
      }
      try {
        const [branchRes, departmentRes] = await Promise.all([
          BranchApi.list(query, true),
          DepartmentApi.list(query, true),
        ]);
        const branchOptions = branchRes.result || [];
        const departmentOptions = departmentRes.result || [];
        const positionOptions = this.fn_filterEmployeePositionOptionsByCompany(selectedCompanyId);
        const contractTypeOptions = this.fn_filterEmployeeContractTypeOptionsByCompany(selectedCompanyId);
        const branchOptionIds = branchOptions.map(item => item.id);
        const departmentOptionIds = departmentOptions.map(item => item.id);
        const positionOptionIds = positionOptions.map(item => item.id);
        const contractTypeOptionIds = contractTypeOptions.map(item => item.id);
        this.mData.dataDefault.listChiNhanh = branchOptions;
        this.mData.dataDefault.listPhongBan = departmentOptions;
        this.mData.dataDefault.listChucVu = positionOptions;
        this.mData.dataDefault.listHopDong = contractTypeOptions.length > 0
          ? [
            {
              id: `${contractTypeOptionIds.join(",")}`,
              name: "Tất cả",
            },
            ...contractTypeOptions,
          ]
          : [];
        if (
          this.mData.tableRules.dataSearch.value["job_info.branch_id"] &&
          !branchOptionIds.includes(this.mData.tableRules.dataSearch.value["job_info.branch_id"])
        ) {
          this.mData.tableRules.dataSearch.value["job_info.branch_id"] = "";
        }
        if (
          this.mData.tableRules.dataSearch.value["job_info.department_id"] &&
          !departmentOptionIds.includes(this.mData.tableRules.dataSearch.value["job_info.department_id"])
        ) {
          this.mData.tableRules.dataSearch.value["job_info.department_id"] = "";
        }
        if (
          this.mData.tableRules.dataSearch.value["job_info.position_id"] &&
          !positionOptionIds.includes(this.mData.tableRules.dataSearch.value["job_info.position_id"])
        ) {
          this.mData.tableRules.dataSearch.value["job_info.position_id"] = "";
        }
        if (
          this.mData.tableRules.dataSearch.value["job_info.contract_type_id"] &&
          !contractTypeOptionIds.includes(this.mData.tableRules.dataSearch.value["job_info.contract_type_id"]) &&
          this.mData.tableRules.dataSearch.value["job_info.contract_type_id"] !== `${contractTypeOptionIds.join(",")}`
        ) {
          this.mData.tableRules.dataSearch.value["job_info.contract_type_id"] = "";
          this.mData.tableRules.dataSearch.value["start_date*end_date"] = undefined;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async fn_handleEmployeeCompanySearchChange() {
      await this.fn_applyEmployeeCompanyDependentOptions();
    },
    changeContractType() {
      if (!this.mData.tableRules.dataSearch.value['job_info.contract_type_id']) this.mData.tableRules.dataSearch.value['start_date*end_date'] = undefined
    },
    forceUpdateUI() {
      this.$forceUpdate()
    },
    changeView(type){
      this.currentView = type;
      this.replaceRouter();
    },
    async downloadTemplate(){
      this.loading = true;
      await this.fn_innitDataDefault("download");
      await MethodService.exportTemplateImportEmployee([],this.mData.dataDefault.listChiNhanh,this.mData.dataDefault.listPhongBan,this.mData.dataDefault.listChucVu,this.mData.dataDefault.listHopDong,'template');
      this.loading = false;
    },
    async fn_innitDataDefault(type) {
      if (type != "download" && this.defaultDataLoaded) {
        return;
      }
      if (type != "download" && this.defaultDataPromise) {
        return this.defaultDataPromise;
      }

      this.mData.companyInfo = MethodService.getCompanyInfo();
      const disabledFilter = type == "download" ? "disabled!=true" : "";
      const loadPromise = Promise.all([
        CompanyApi.GetCompanyFilterOptions({}, true),
        CompanyApi.list({ limit: 1000000 }, true),
        BranchApi.list({ limit: 10000, filters: disabledFilter }, true),
        DepartmentApi.list({ limit: 10000, filters: disabledFilter }, true),
        PositionApi.list({ limit: 10000, filters: disabledFilter }, true),
        ContractTypeApi.list({ limit: 10000, filters: "disabled!=true" }, true),
        QualificationApi.list({ limit: 10000, filters: disabledFilter }, true),
        MajorApi.list({ limit: 10000, filters: disabledFilter }, true),
        RelationshipApi.list({ limit: 10000, filters: disabledFilter }, true),
        RankSalaryApi.list({ limit: 10000, filters: disabledFilter }, true),
        CoefficientSalaryApi.list({ limit: 10000, filters: disabledFilter }, true),
        SubsidiesSalaryTypeApi.list({ limit: 10000, filters: disabledFilter }, true),
        ShiftApi.list({ limit: 10000 }, true),
      ]).then(async (responses) => {
        const [
          companyFilterApiRes,
          companyApiRes,
          branchApiRes,
          departmentApiRes,
          positionApiRes,
          contractTypeApiRes,
          qualificationApiRes,
          majorApiRes,
          relationshipApiRes,
          rankSalaryApiRes,
          coefficientSalaryApiRes,
          subsidiesSalaryTypeApiRes,
          shiftApiRes,
        ] = responses;

        const companyFilterOptions = this.fn_normalizeCompanyOptions(companyFilterApiRes.result);
        const allCompanies = this.fn_normalizeCompanyOptions(companyApiRes.result);
        const scopedCompaniesFromTree = this.fn_getCompanyTreeScope(
          allCompanies,
          this.mData.companyInfo && this.mData.companyInfo.id
            ? this.mData.companyInfo.id
            : undefined
        );
        this.mData.dataDefault.listCompanyAll = allCompanies;
        this.mData.dataDefault.listCompany = this.fn_mergeCompanyScope(
          companyFilterOptions,
          scopedCompaniesFromTree
        );

        const listHopDong = (contractTypeApiRes.result || []).slice();

        this.mData.dataDefault.listChiNhanhAll = branchApiRes.result || [];
        this.mData.dataDefault.listPhongBanAll = departmentApiRes.result || [];
        this.mData.dataDefault.listChucVuAll = positionApiRes.result || [];
        this.mData.dataDefault.listChucVu = positionApiRes.result || [];
        this.mData.dataDefault.listHopDongAll = listHopDong;
        this.mData.dataDefault.listTrinhDo = qualificationApiRes.result || [];
        this.mData.dataDefault.listChuyenNganh = majorApiRes.result || [];
        this.mData.dataDefault.listQuanHe = relationshipApiRes.result || [];
        this.mData.dataDefault.listBacLuong = rankSalaryApiRes.result || [];
        this.mData.dataDefault.listHeSoLuong = coefficientSalaryApiRes.result || [];
        this.mData.dataDefault.listTroCap = subsidiesSalaryTypeApiRes.result || [];
        this.mData.dataDefault.listShift = shiftApiRes.result || [];
        this.mData.dataDefault.listHopDong = listHopDong;
        await this.fn_applyEmployeeCompanyDependentOptions();

        if (type != "download") {
          this.defaultDataLoaded = true;
        }
      }).finally(() => {
        if (type != "download") {
          this.defaultDataPromise = null;
        }
      });

      if (type != "download") {
        this.defaultDataPromise = loadPromise;
      }

      return loadPromise;
    },
    async renderTableDataInChunks(rows) {
      const renderToken = ++this.listRenderToken;
      const normalizedRows = Array.isArray(rows) ? rows : [];
      const chunkSize = normalizedRows.length > 40 ? 20 : 10;

      this.mData.tableRules.data = [];

      if (normalizedRows.length == 0) {
        return;
      }

      for (let index = 0; index < normalizedRows.length; index += chunkSize) {
        if (renderToken !== this.listRenderToken) {
          return;
        }

        this.mData.tableRules.data = this.mData.tableRules.data.concat(
          normalizedRows.slice(index, index + chunkSize)
        );

        if (index + chunkSize < normalizedRows.length) {
          await new Promise((resolve) => {
            window.requestAnimationFrame(() => resolve());
          });
        }
      }
    },
    async fn_initTable() {
      this.loading = true;
      try {
        if (!this.defaultDataLoaded) {
          try {
            await this.fn_innitDataDefault();
          } catch (error) {
            console.log("error load default employee data", error);
          }
        }
        this.dataFilter = {
          filters: this.mData.tableRules.filters,
        };
        if (this.mData.tableRules.allowPaging) {
          this.dataFilter.limit = this.mData.tableRules.limit;
          this.dataFilter.offset = this.mData.tableRules.offset;
        }
        if (this.mData.tableRules.allowSorting) {
          this.dataFilter.sort = this.mData.tableRules.sort;
        }
        if (this.mData.tableRules.showUrl) {
          this.replaceRouter();
        }
        this.dataFilter.companyInfo = this.mData.companyInfo; 
        if (this.dataFilter.companyInfo && this.dataFilter.companyInfo.id) {
          this.dataFilter.companyId = this.dataFilter.companyInfo.id;
        }
        const condition = (this.mData.tableRules.dataSearch.value.condition || "").trim();
        if (condition) {
          const fullData = (await this.fn_getEmployeeConditionSourceData())
            .map((item, index) => ({
              item,
              index,
              score: this.fn_getEmployeeConditionScore(item, condition),
            }))
            .filter((item) => item.score > 0)
            .sort((a, b) => this.fn_sortEmployeeConditionResult(a, b))
            .map((item) => item.item);
          const pageData = this.mData.tableRules.allowPaging
            ? fullData.slice(this.mData.tableRules.offset, this.mData.tableRules.offset + this.mData.tableRules.limit)
            : fullData;
          this.getDataEmployeeDraff(MethodService.findListItemDifferent(pageData, "id"));
          setTimeout(() => {
            this.loading = false;
          }, 120);
          await this.renderTableDataInChunks(pageData);
          this.mData.tableRules.total = fullData.length;
          this.mData.tableRules.page = this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
          return;
        }

        let res = await EmployeeApi.list(this.dataFilter, true);

        if (res.result) {
          let resData = await this.fn_changeData(res.result);
          let arrEmployeeIds = MethodService.findListItemDifferent(resData, "id");
          this.getDataEmployeeDraff(arrEmployeeIds);
          setTimeout(() => {
            this.loading = false;
          }, 120);
          await this.renderTableDataInChunks(resData);
          this.mData.tableRules.total = res.meta.total;
          if (resData) {
            this.mData.tableRules.page = this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
            if(
                this.mData.tableRules.offset == this.mData.tableRules.total &&
                this.mData.tableRules.page > 1
              ) {
              this.mData.tableRules.page = this.mData.tableRules.page - 1;
              this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
              this.fn_initTable();
            }
          }
        } else {
          this.mData.tableRules.data = [];
          this.mData.tableRules.total = 0;
          this.loading = false;
        }
      } catch (error) {
        console.error("Error in fn_initTable:", error);
        this.mData.tableRules.data = [];
        this.mData.tableRules.total = 0;
        this.loading = false;
      }
    },
    async fn_getEmployeeConditionSourceData() {
      const cacheKey = JSON.stringify({
        filters: this.dataFilter.filters,
        sort: this.dataFilter.sort,
        companyId: this.dataFilter.companyId,
      });

      if (this.employeeConditionCacheKey === cacheKey) {
        return this.employeeConditionCacheData;
      }

      const countRes = await EmployeeApi.list({ ...this.dataFilter, limit: 1, offset: 0 }, true);
      const total = countRes && countRes.meta && countRes.meta.total ? countRes.meta.total : 0;
      const fullRes = total > 0
        ? await EmployeeApi.list({ ...this.dataFilter, limit: total, offset: 0 }, true)
        : { result: [] };
      const fullData = await this.fn_changeData(fullRes.result || []);

      this.employeeConditionCacheKey = cacheKey;
      this.employeeConditionCacheData = fullData;
      return fullData;
    },
    fn_getEmployeeConditionScore(item, condition) {
      const rawKeyword = `${condition || ""}`.trim().toLowerCase();
      const aliasKeyword = MethodService.changeAlias(condition || "");
      if (!rawKeyword && !aliasKeyword) return 1;
      const hasAccentedKeyword = rawKeyword !== aliasKeyword;
      const normalizeValue = (value) => ({
        raw: `${value || ""}`.toLowerCase(),
        alias: MethodService.changeAlias(`${value || ""}`),
      });
      const scoreByMatch = (source, exact, startsWith, includes, rawBonus = 20) => {
        if (!source.raw) return 0;
        if (source.raw === rawKeyword) return exact + rawBonus;
        if (source.raw.startsWith(rawKeyword)) return startsWith + rawBonus;
        if (source.raw.includes(rawKeyword)) return includes + rawBonus;
        if (hasAccentedKeyword) return 0;
        if (source.alias === aliasKeyword) return exact;
        if (source.alias.startsWith(aliasKeyword)) return startsWith;
        if (source.alias.includes(aliasKeyword)) return includes;
        return 0;
      };

      const fullName = item.administrative_info && item.administrative_info.name
        ? item.administrative_info.name.full_name
        : "";
      const firstName = item.administrative_info && item.administrative_info.name
        ? item.administrative_info.name.first_name
        : "";
      const fullNameSource = normalizeValue(fullName);
      const firstNameSource = normalizeValue(firstName);
      const fullNameWords = fullNameSource.raw.split(" ").filter(Boolean);
      const aliasFullNameWords = fullNameSource.alias.split(" ").filter(Boolean);
      const fullNameScore = Math.max(
        scoreByMatch(firstNameSource, 280, 260, 0),
        scoreByMatch(fullNameSource, 240, 180, 160),
        fullNameWords.some((word) => word === rawKeyword) ? 240 : 0,
        fullNameWords.some((word) => word.startsWith(rawKeyword)) ? 220 : 0,
        fullNameSource.raw.includes(` ${rawKeyword}`) ? 180 : 0,
        hasAccentedKeyword ? 0 : (
          (aliasFullNameWords.some((word) => word === aliasKeyword) ? 200 : 0) ||
          (aliasFullNameWords.some((word) => word.startsWith(aliasKeyword)) ? 180 : 0) ||
          (fullNameSource.alias.includes(` ${aliasKeyword}`) ? 140 : 0)
        )
      );

      return Math.max(
        fullNameScore,
        scoreByMatch(normalizeValue(item.employee_no), 70, 60, 50),
        scoreByMatch(normalizeValue(item.administrative_info && item.administrative_info.phone_number), 45, 40, 35),
        scoreByMatch(normalizeValue(item.administrative_info && item.administrative_info.identify_card), 34, 30, 25),
        scoreByMatch(normalizeValue(item.administrative_info && item.administrative_info.email), 24, 20, 15),
        scoreByMatch(normalizeValue(item.administrative_info && item.administrative_info.company_email), 14, 10, 5)
      );
    },
    fn_getEmployeeConditionStatusPriority(status) {
      const normalizedStatus = MethodService.changeAlias(`${status || ""}`).toLowerCase();

      if (status === "DANG_LAM_VIEC" || normalizedStatus === "dang lam viec") {
        return 0;
      }
      if (status === "DA_NGHI" || normalizedStatus === "da nghi viec" || normalizedStatus === "da nghi") {
        return 1;
      }
      if (status === "NGHI_SINH" || normalizedStatus === "nghi sinh") {
        return 2;
      }

      return 3;
    },
    fn_sortEmployeeConditionResult(a, b) {
      return (
        this.fn_getEmployeeConditionStatusPriority(a.item && a.item.status) -
        this.fn_getEmployeeConditionStatusPriority(b.item && b.item.status) ||
        b.score - a.score ||
        a.index - b.index
      );
    },
    async getDataEmployeeDraff(arrIds) {
      const employeeDraffApiRes = await EmployeeDraffApi.list({
        limit: arrIds.length,
        filters: `employee_id:in:${arrIds.join(',')}&approver:is_null:true`
      }, true);
      const employeeSignatureDraffApiRes = await EmployeeSignatureDraffApi.list({
        limit: arrIds.length,
        filters: `employee_id:in:${arrIds.join(',')}&approver:is_null:true`
      }, true)
      this.mData.dataDefault.listEmployeeDraff = employeeDraffApiRes.result;
      this.mData.dataDefault.listEmployeeSignatureDraff = employeeSignatureDraffApiRes.result;
    },
    checkHaveDraff(employeeId) {
      let employeeDraff = this.mData.dataDefault.listEmployeeDraff.find(item => item.employee_id == employeeId);
      let employeeSignatureDraff = this.mData.dataDefault.listEmployeeSignatureDraff.find(item => item.employee_id == employeeId);
      return employeeDraff || employeeSignatureDraff
    },
    replaceRouter() {
      this.$router
      .replace({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
          view: this.currentView,
          constractValidity: this.mData.tableRules.dataSearch.value['start_date*end_date'],
          seniority: this.mData.tableRules.dataSearch.value['start_work_date'],
          condition: this.mData.tableRules.dataSearch.value.condition,
        },
      })
      .catch((err) => {});
    },
    handleSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.handleChangeOffset(this.mData.tableRules.page);
    },
    handleCurentChange(page) {
      this.handleChangeOffset(page);
    },
    handlePrevClick(page) {
      this.handleChangeOffset(page);
    },
    handleNextClick(page) {
      this.handleChangeOffset(page);
    },
    handleChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    load(){
      this.mData.tableRules.limit = this.mData.tableRules.limit + 10;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_changeData(resData) {
      resData.forEach((item) => {
        if(
          item.image_id
        ){
          item.avataUrl = ExtensionService.urlImg + item.image_id +"&r=square&w=900";
        } else if (
          item.administrative_info &&
          item.administrative_info.avatar_id
        ) {
          item.avataUrl = ExtensionService.urlImg + item.administrative_info.avatar_id +"&r=square&w=900";
        } else {
          item.avataUrl = 'img/demo.png';
        }
        if (item.status == "DANG_LAM_VIEC") {
          item.status = "Đang làm việc";
        } else if (item.status == "DA_NGHI") {
          item.status = "Đã nghỉ việc";
        } else if (item.status == "NGHI_SINH") {
          item.status = "Nghỉ sinh";
        }
        item.chuc_vu = "";
        item.phong_ban = "";
        item.chi_nhanh = "";
        let curentTime = new Date().getTime();
        let validJobInfo = (item.job_info || []).filter((e) => {
          if (e.end_date) {
            return (
              new Date(e.start_date).getTime() <= curentTime &&
              curentTime <= new Date(e.end_date).getTime()
            );
          } else {
            return new Date(e.start_date).getTime() <= curentTime;
          }
        });
        let chucVu = this.mData.dataDefault.listChucVu.find((element) => {
          return (
            element.id ==
            (validJobInfo[0] && validJobInfo[0].position_id
              ? validJobInfo[0].position_id
              : "")
          );
        });
        let phongBan = this.mData.dataDefault.listPhongBan.find((element) => {
          return (
            element.id ==
            (validJobInfo[0] && validJobInfo[0].department_id
              ? validJobInfo[0].department_id
              : "")
          );
        });
        let chiNhanh = this.mData.dataDefault.listChiNhanh.find((element) => {
          return (
            element.id ==
            (validJobInfo[0] && validJobInfo[0].branch_id
              ? validJobInfo[0].branch_id
              : "")
          );
        });
        if (chucVu && chucVu.name) {
          item.chuc_vu = chucVu.name;
        } else {
          item.chuc_vu = " ";
        }
        if (phongBan && phongBan.name) {
          item.phong_ban = phongBan.name;
        } else {
          item.phong_ban = " ";
        }
        if (chiNhanh && chiNhanh.name) {
          item.chi_nhanh = chiNhanh.name;
        } else {
          item.chi_nhanh = " ";
        }
      });
      return resData;
    },
    fn_handle(type,id) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: id },
          query: {
            filters: this.dataFilter.filters,
            page: this.mData.tableRules.page,
            limit: this.dataFilter.limit,
            offset: this.dataFilter.offset,
            sort: this.dataFilter.sort
          }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteEmployeeConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
        .then(() => {
          this.fn_delete(id);
        }).catch(() => {});
      }
      if (type == "approve") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-approve",
          params: { id: id },
          query: {
            filters: this.dataFilter.filters,
            page: this.mData.tableRules.page,
            limit: this.dataFilter.limit,
            offset: this.dataFilter.offset,
            sort: this.dataFilter.sort
          }
        });
      }
    },
    async fn_delete(id) {
      try {
        await EmployeeApi.delete(id);
        this.fn_initTable();
      } catch (error) {
        console.log(error);
        if (error.code == 500) {
          window.toastr.error(error.message);
        } else {
          window.toastr.error("Xóa nhân viên thất bại!");
        }
      }
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value.condition) {
        this.mData.tableRules.dataSearch.value.condition =
          this.mData.tableRules.dataSearch.value.condition.trim();
      }
      if (this.$route.query.constractValidity) this.$route.query.constractValidity = undefined
      delete this.mData.tableRules.dataSearch.value.job_info
      this.mData.tableRules.filters = ''
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          const dataSearch = JSON.parse(JSON.stringify(this.mData.tableRules.dataSearch));
          dataSearch.value.condition = "";
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },
    async exportDataEmployee() {
      await this.fn_innitDataDefault("download");
      const normalizeFilterValue = (value) =>
        value === "" || value === null || value === undefined ? undefined : value;
      const selectedStatus = this.mData.tableRules.dataSearch.value.status;
      const selectedCompanyId = normalizeFilterValue(this.mData.tableRules.dataSearch.value.company_id);
      const baseFilter = {
        bId: normalizeFilterValue(this.mData.tableRules.dataSearch.value["job_info.branch_id"]),
        dId: normalizeFilterValue(this.mData.tableRules.dataSearch.value["job_info.department_id"]),
        pId: normalizeFilterValue(this.mData.tableRules.dataSearch.value["job_info.position_id"]),
        gender: normalizeFilterValue(this.mData.tableRules.dataSearch.value["administrative_info.gender"]),
        status: selectedStatus && selectedStatus.indexOf(",") === -1 ? selectedStatus : undefined,
      };
      let employeeExcelResult = [];

      if (selectedCompanyId) {
        const employeeExcel = await EmployeeApi.getListEmployeeDetail(
          { ...baseFilter, cId: selectedCompanyId },
          true
        );
        employeeExcelResult = (employeeExcel.result || []).map((item) => ({
          ...item,
          company_id: item.company_id || selectedCompanyId,
        }));
      } else {
        const companyIds = (this.mData.dataDefault.listCompanyAll || [])
          .map((item) => item && item.id)
          .filter(Boolean);
        const responses = await Promise.all(
          companyIds.map(async (companyId) => ({
            companyId,
            response: await EmployeeApi.getListEmployeeDetail({ ...baseFilter, cId: companyId }, true),
          }))
        );
        employeeExcelResult = responses
          .flatMap(({ companyId, response }) =>
            response && response.result
              ? response.result.map((item) => ({
                ...item,
                company_id: item.company_id || companyId,
              }))
              : []
          )
          .filter((item, index, arr) => arr.findIndex((employee) => employee && employee.id === item.id) === index);
      }
      const filteredEmployeeExcel = this.fn_filterEmployeeExportByCondition(
        this.fn_filterEmployeeExportBySeniority(
          this.fn_filterEmployeeExportByInsurance(
            this.fn_filterEmployeeExportByContract(employeeExcelResult)
          )
        )
      );
      if (filteredEmployeeExcel.length === 0) {
        window.toastr.warning("Không có dữ liệu để xuất file");
        return;
      }
      let data = await this.fn_changeDataExportExcel(filteredEmployeeExcel);
      MethodService.exportExcel(data);

    },
    fn_filterEmployeeExportByContract(data) {
      const contractTypeValue = this.mData.tableRules.dataSearch.value["job_info.contract_type_id"];
      const contractValidityValue = this.mData.tableRules.dataSearch.value["start_date*end_date"];
      const contractTypeIds = contractTypeValue
        ? `${contractTypeValue}`.split(",").map((item) => `${item}`.trim()).filter(Boolean)
        : [];

      if (contractTypeIds.length === 0 && !contractValidityValue) return data;

      const now = new Date();
      const oneMonthLater = new Date(now.getTime());
      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const nowTime = now.getTime();
      const oneMonthLaterTime = oneMonthLater.getTime();
      const currentDateTime = currentDate.getTime();
      const getJobTimeRange = (job) => ({
        startTime: job.start_date ? new Date(job.start_date).getTime() : null,
        endTime: job.end_date ? new Date(job.end_date).getTime() : null,
      });
      const isMatchedJob = (job) =>
        contractTypeIds.length === 0 || contractTypeIds.includes(`${job.contract_type_id}`);
      const isValidated = (job) => {
        const { startTime, endTime } = getJobTimeRange(job);
        return startTime !== null && startTime <= nowTime && (endTime === null || endTime >= nowTime);
      };
      const isAboutToExpire = (job) => {
        const { startTime, endTime } = getJobTimeRange(job);
        return startTime !== null && endTime !== null && startTime <= nowTime && endTime >= nowTime && endTime <= oneMonthLaterTime;
      };
      const isLongTermOrNoEndDate = (job) => {
        const { endTime } = getJobTimeRange(job);
        return endTime === null || endTime >= oneMonthLaterTime;
      };
      const isNonExpired = (job) => {
        const { endTime } = getJobTimeRange(job);
        return endTime === null || endTime >= currentDateTime;
      };

      return data.filter((item) => {
        const jobInfos = Array.isArray(item.job_info) ? item.job_info : [];
        const matchedJobs = jobInfos.filter(isMatchedJob);
        if (matchedJobs.length === 0) return false;

        switch (contractValidityValue) {
          case "validated":
            return matchedJobs.some(isValidated);
          case "about_to_expire":
            return matchedJobs.some(isAboutToExpire) && !matchedJobs.some(isLongTermOrNoEndDate);
          case "expired":
            return !matchedJobs.some(isNonExpired);
          default:
            return true;
        }
      });
    },
    fn_filterEmployeeExportByInsurance(data) {
      const selectedInsurance = this.mData.tableRules.dataSearch.value["salary.insurance_salary"];
      if (selectedInsurance !== "true" && selectedInsurance !== "false") return data;

      return data.filter((item) => {
        const insuranceSalary = item && item.salary ? item.salary.insurance_salary : undefined;
        const hasInsurance = insuranceSalary !== null && insuranceSalary !== undefined && `${insuranceSalary}` !== "";
        return selectedInsurance === "false" ? hasInsurance : !hasInsurance;
      });
    },
    fn_filterEmployeeExportBySeniority(data) {
      const selectedSeniority = this.mData.tableRules.dataSearch.value["start_work_date"];
      if (!selectedSeniority) return data;

      return data.filter((item) => {
        const seniority = MethodService.calculatorSeniority(item ? item.start_work_date : undefined);

        switch (selectedSeniority) {
          case "0-1":
            return seniority < 1;
          case "1-3":
            return seniority >= 1 && seniority < 3;
          case "3-5":
            return seniority >= 3 && seniority < 5;
          case "5-7":
            return seniority >= 5 && seniority < 7;
          case "7-0":
            return seniority >= 7;
          default:
            return true;
        }
      });
    },
    fn_filterEmployeeExportByCondition(data) {
      const condition = (this.mData.tableRules.dataSearch.value.condition || "").trim();
      if (!condition) return data;

      return data
        .map((item, index) => ({
          item,
          index,
          score: this.fn_getEmployeeConditionScore(item, condition),
        }))
        .filter((item) => item.score > 0)
        .sort((a, b) => this.fn_sortEmployeeConditionResult(a, b))
        .map((item) => item.item);
    },
    fn_getEmployeeCompanyEmail(employee) {
      const company = (this.mData.dataDefault.listCompanyAll || []).find(
        (item) => item && employee && item.id == employee.company_id
      );
      return company && company.contact && company.contact.email
        ? company.contact.email
        : "";
    },
    async fn_buildDirectManagerMap(employees) {
      const now = Date.now();
      const employeeManagerMap = {};
      const managerNameMap = {};

      const getDirectManagerId = (employee) => {
        const activeJob = (employee.job_info || []).find((job) => {
          if (!job) return false;
          const startTime = job.start_date ? new Date(job.start_date).getTime() : 0;
          const endTime = job.end_date ? new Date(job.end_date).getTime() : Infinity;
          return startTime <= now && now <= endTime;
        });
        return (
          (activeJob && activeJob.direct_manager_id) ||
          ((employee.job_info || []).find((job) => job && job.direct_manager_id) || {}).direct_manager_id ||
          ""
        );
      };

      const getManagerName = async (managerId) => {
        try {
          const apiRes = await EmployeeApi.findById(managerId, true);
          const manager = apiRes && apiRes.result ? apiRes.result : null;
          return (
            (manager &&
              (manager.full_name ||
                (manager.name && manager.name.full_name) ||
                (manager.administrative_info &&
                manager.administrative_info.name &&
                manager.administrative_info.name.full_name))) ||
            ""
          );
        } catch (error) {
          console.error("Không tải được quản lý trực tiếp khi xuất nhân sự", managerId, error);
          return "";
        }
      };

      (employees || []).forEach((employee) => {
        if (employee && employee.id) {
          employeeManagerMap[employee.id] = getDirectManagerId(employee);
        }
      });

      const managerIds = [...new Set(Object.values(employeeManagerMap).filter(Boolean))];
      for (let index = 0; index < managerIds.length; index += 10) {
        const chunk = managerIds.slice(index, index + 10);
        const responses = await Promise.all(
          chunk.map(async (managerId) => ({
            managerId,
            managerName: await getManagerName(managerId),
          }))
        );
        responses.forEach((item) => {
          managerNameMap[item.managerId] = item.managerName;
        });
      }

      return Object.keys(employeeManagerMap).reduce((result, employeeId) => {
        const managerId = employeeManagerMap[employeeId];
        result[employeeId] = managerNameMap[managerId] || "";
        return result;
      }, {});
    },
    async fn_changeDataExportExcel(data) {
      const selectedStatus = this.mData.tableRules.dataSearch.value.status;
      const selectedGender = this.mData.tableRules.dataSearch.value["administrative_info.gender"];
      const selectedStatuses = selectedStatus
        ? selectedStatus.split(",").map(item => item.trim()).filter(Boolean)
        : [];
      let dataFilterGender = selectedGender === "" || selectedGender === undefined || selectedGender === null
        ? data
        : data.filter((item) => {
          const itemGender = item.gender !== undefined
            ? item.gender
            : item.administrative_info && item.administrative_info.gender !== undefined
              ? item.administrative_info.gender
              : undefined;
          return Number(itemGender) === Number(selectedGender);
        });
      let dataFilterStatus = selectedStatuses.length > 0
        ? dataFilterGender.filter(item => selectedStatuses.includes(item.status))
        : dataFilterGender;
      let directManagerMap = await this.fn_buildDirectManagerMap(dataFilterStatus);
      dataFilterStatus.forEach((item, index) => {
        let curentTime = new Date().getTime();
        //giới tính
        item.gender = item.gender === 0
                        ? "Nữ"
                        : item.gender === 1
                          ? "Nam"
                          : "Khác";
        if (item.status == "DANG_LAM_VIEC") {
          item.status = "Đang làm việc";
        } else if (item.status == "DA_NGHI") {
          item.status = "Đã nghỉ";
        } else if (item.status == "NGHI_SINH") {
          item.status = "Nghỉ sinh";
        }
        item.full_name =
          item &&
          item.administrative_info &&
          item.administrative_info.name &&
          item.administrative_info.name.full_name
            ? item.administrative_info.name.full_name
            : [item.last_name, item.first_name]
                .filter((value) => value && value.toString().trim() != "")
                .join(" ")
                .trim();
        item.start_work_date_display = "";
        item.direct_manager_name = item.id && directManagerMap[item.id]
          ? directManagerMap[item.id]
          : "";
        item.company_email = this.fn_getEmployeeCompanyEmail(item);

        let validJobInfo = (item.job_info || []).filter((e) => {
          if (e.end_date) {
            return (
              new Date(e.start_date).getTime() <= curentTime &&
              curentTime <= new Date(e.end_date).getTime()
            );
          } else {
            return new Date(e.start_date).getTime() <= curentTime;
          }
        });
        item.start_work_date_display = validJobInfo[0] && validJobInfo[0].start_date
          ? this.formatDate(validJobInfo[0].start_date)
          : item.start_work_date
            ? this.formatDate(item.start_work_date)
            : "";

        let validDependentPerson = (item.dependent_person_info || []).filter(e => {
          if (e.expired_date) {
            return (
              new Date(e.registered_date).getTime() <= curentTime &&
              curentTime <= new Date(e.expired_date).getTime()
            );
          } else {
            return new Date(e.registered_date).getTime() <= curentTime;
          }
        });
        let arrNameHopDong = [];
        let arrNameChucVu = [];
        let arrNamePhongBan = [];
        let arrNameChiNhanh = [];
        let arrJobStartDate = [];
        let arrJobEndDate = [];
        validJobInfo.forEach(e => {
          let hopDong = this.mData.dataDefault.listHopDong.find((element) => {
            return element.id == e.contract_type_id
          });
          let chucVu = this.mData.dataDefault.listChucVu.find((element) => {
            return element.id == e.position_id
          });
          let phongBan = this.mData.dataDefault.listPhongBan.find((element) => {
            return element.id == e.department_id
          });
          let chiNhanh = this.mData.dataDefault.listChiNhanh.find((element) => {
            return element.id == e.branch_id
          });
          if (hopDong && hopDong.name) arrNameHopDong.push(hopDong.name);
          if (chucVu && chucVu.name) arrNameChucVu.push(chucVu.name);
          if (phongBan && phongBan.name) arrNamePhongBan.push(phongBan.name);
          if (chiNhanh && chiNhanh.name) arrNameChiNhanh.push(chiNhanh.name);
          arrJobStartDate.push(this.formatDate(e.start_date));
          arrJobEndDate.push(this.formatDate(e.end_date));
        })
        item.contract_name = arrNameHopDong.length > 0 ? `- ${arrNameHopDong.join(`\r\n- `)}` : "" ;
        item.position_name = arrNameChucVu.length > 0 ? `- ${arrNameChucVu.join(`\r\n- `)}` : "" ;
        item.department_name = arrNamePhongBan.length > 0 ? `- ${arrNamePhongBan.join(`\r\n- `)}` : "" ;
        item.branch_name = arrNameChiNhanh.length > 0 ? `- ${arrNameChiNhanh.join(`\r\n- `)}` : "" ;
        item.start_date = arrJobStartDate.length > 0 ? `- ${arrJobStartDate.join(`\r\n- `)}` : "" ;
        item.end_date = arrJobEndDate.length > 0 ? `- ${arrJobEndDate.join(`\r\n- `)}` : "" ;

        //Ca làm việc
        let validShift = (item.employee_shifts || []).filter((e) => {
          if (e.end_time) {
            return (
              new Date(e.start_time).getTime() <= curentTime &&
              curentTime <= new Date(e.end_time).getTime()
            );
          } else {
            return new Date(e.start_time).getTime() <= curentTime;
          }
        });
        let arrNameShift = [];
        let arrShiftStartTime = [];
        let arrShiftEndTime = [];
        validShift.forEach((e) => {
          let caLamViec = this.mData.dataDefault.listShift.find((element) => {
            return element.id == e.shift_id;
          });
          if (caLamViec && caLamViec.name) arrNameShift.push(caLamViec.name);
          arrShiftStartTime.push(this.formatDate(e.start_time));
          arrShiftEndTime.push(this.formatDate(e.end_time));
        });
        item.shift_name = arrNameShift.length > 0 ? `- ${arrNameShift.join(`\r\n- `)}` : "" ;
        item.start_time = arrShiftStartTime.length > 0 ? `- ${arrShiftStartTime.join(`\r\n- `)}` : "" ;
        item.end_time = arrShiftEndTime.length > 0 ? `- ${arrShiftEndTime.join(`\r\n- `)}` : "" ;

        //Trịnh độ chuyên môn
        let arrNameTrinhDo = [];
        let arrNameChuyenNganh = [];
        let arrQualificationIssuedDate = [];
        let arrQualificationIssuedBy = [];
        let arrQualificationNote = [];
        (item.qualification || []).forEach(e => {
          let qualification = this.mData.dataDefault.listTrinhDo.find((element) => {
            return element.id == e.qualification_id
          });
          let major = this.mData.dataDefault.listChuyenNganh.find((element) => {
            return element.id == e.major_id
          });
          if (qualification && qualification.name) arrNameTrinhDo.push(qualification.name);
          if (major && major.name) arrNameChuyenNganh.push(major.name);
          arrQualificationIssuedDate.push(this.formatDate(e.issued_date));
          arrQualificationIssuedBy.push(e.issued_by);
          arrQualificationNote.push(e.note);
        });
        item.qualification_name = arrNameTrinhDo.length > 0 ? `- ${arrNameTrinhDo.join(`\r\n- `)}` : "" ;
        item.major_name = arrNameChuyenNganh.length > 0 ? `- ${arrNameChuyenNganh.join(`\r\n- `)}` : "" ;
        item.qualification_issued_date = arrQualificationIssuedDate.length > 0 ? `- ${arrQualificationIssuedDate.join(`\r\n- `)}` : "" ;
        item.qualification_issued_by = arrQualificationIssuedBy.length > 0 ? `- ${arrQualificationIssuedBy.join(`\r\n- `)}` : "" ;
        item.qualification_note = arrQualificationNote.length > 0 ? `- ${arrQualificationNote.join(`\r\n- `)}` : "" ;

        //Chứng chỉ
        let arrNameCertificate = [];
        let arrIssuedDateCertificate = [];
        let arrIssuedByCertificate = [];
        let arrNoteCertificate = [];
        (item.certificate || []).forEach(e => {
          arrNameCertificate.push(e.name);
          arrIssuedDateCertificate.push(this.formatDate(e.issued_date));
          arrIssuedByCertificate.push(e.issued_by);
          arrNoteCertificate.push(e.note);
        })
        item.certificate_name = arrNameCertificate.length > 0 ? `- ${arrNameCertificate.join(`\r\n- `)}` : "" ;
        item.certificate_issued_date = arrIssuedDateCertificate.length > 0 ? `- ${arrIssuedDateCertificate.join(`\r\n- `)}` : "" ;
        item.certificate_issued_by = arrIssuedByCertificate.length > 0 ? `- ${arrIssuedByCertificate.join(`\r\n- `)}` : "" ;
        item.certificate_note = arrNoteCertificate.length > 0 ? `- ${arrNoteCertificate.join(`\r\n- `)}` : "" ;
        //Thông tin liên hệ khác
        let arrOtherContactName = [];
        let arrOtherContactNameRelationship = [];
        let arrOtherContactPhone = [];
        let arrOtherContactAddress = [];
        (item.other_contact_info || []).forEach(e => {
          arrOtherContactName.push(e.full_name);
          arrOtherContactPhone.push(e.phone_number);
          if(e.address != "" && e.address != undefined) arrOtherContactAddress.push(e.address);
          let relationship = this.mData.dataDefault.listQuanHe.find((element) => {
            return element.id == e.relationship_id
          });
          if (relationship && relationship.name) arrOtherContactNameRelationship.push(relationship.name);
        });
        item.other_contact_info_name = arrOtherContactName.length > 0 ? `- ${arrOtherContactName.join(`\r\n- `)}` : "" ;
        item.other_contact_info_relationship = arrOtherContactNameRelationship.length > 0 ? `- ${arrOtherContactNameRelationship.join(`\r\n- `)}` : "" ;
        item.other_contact_info_phone = arrOtherContactPhone.length > 0 ? `- ${arrOtherContactPhone.join(`\r\n- `)}` : "" ;
        item.other_contact_info_address = arrOtherContactAddress.length > 0 ? `- ${arrOtherContactAddress.join(`\r\n- `)}` : "" ;

        //Lương/Trợ cấp
        item.payment_method = item.salary && item.salary.payment_method ? item.salary.payment_method : "";
        item.bank_account = item.salary && item.salary.bank_account ? item.salary.bank_account : "";
        item.bank_name = item.salary && item.salary.bank_name ? item.salary.bank_name : "";
        item.bank_branch = item.salary && item.salary.bank_branch ? item.salary.bank_branch : "";
        item.gross_salary = item.salary && item.salary.gross_salary ? item.salary.gross_salary : "";
        item.insurance_salary = item.salary && item.salary.insurance_salary ? item.salary.insurance_salary : "";
        let arrTypeSubsidies = [];
        (item.salary && item.salary.subsidies_salary ? item.salary.subsidies_salary : []).forEach(e => {
          let typeSubsidies = this.mData.dataDefault.listTroCap.find((element) => {
            return element.id == e.subsidies_salary_type_id
          });
          if (typeSubsidies && typeSubsidies.name) arrTypeSubsidies.push(`${typeSubsidies.name} : ${e.value ? e.value : ''}`);
        })
        item.subsidies_salary_name = arrTypeSubsidies.length > 0 ? `- ${arrTypeSubsidies.join(`\r\n- `)}` : "" ;
        let rankSalary = this.mData.dataDefault.listBacLuong.find((element) => {
          return element.id == (item.salary && item.salary.rank_salary_id ? item.salary.rank_salary_id : "" )
        });
        item.rank_salary = rankSalary && rankSalary.name ? rankSalary.name : "";
        let coefficientSalary = this.mData.dataDefault.listHeSoLuong.find((element) => {
          return element.id == (item.salary && item.salary.coefficient_salary_id ? item.salary.coefficient_salary_id : "" )
        });
        item.coefficient_salary = coefficientSalary && coefficientSalary.name ? coefficientSalary.name : "";

        //Thông tin người phụ thuộc
        let arrDependentPersonName = [];
        let arrDependentPersonRelationship = [];
        let arrDependentPersonRegisteredDate = [];
        let arrDependentPersonExpiredDate = [];
        validDependentPerson.forEach(e => {
          arrDependentPersonName.push(e.full_name);
          let relationship = this.mData.dataDefault.listQuanHe.find((element) => {
            return element.id == e.relationship_id
          });
          if (relationship && relationship.name) arrDependentPersonRelationship.push(relationship.name);
          arrDependentPersonRegisteredDate.push(this.formatDate(e.registered_date));
          arrDependentPersonExpiredDate.push(this.formatDate(e.expired_date));
        })
        item.dependent_person_name = arrDependentPersonName.length > 0 ? `- ${arrDependentPersonName.join(`\r\n- `)}` : "" ;
        item.dependent_person_relationship = arrDependentPersonRelationship.length > 0 ? `- ${arrDependentPersonRelationship.join(`\r\n- `)}` : "" ;
        item.dependent_person_registered_date = arrDependentPersonRegisteredDate.length > 0 ? `- ${arrDependentPersonRegisteredDate.join(`\r\n- `)}` : "" ;
        item.dependent_person_expired_date = arrDependentPersonExpiredDate.length > 0 ? `- ${arrDependentPersonExpiredDate.join(`\r\n- `)}` : "" ;

        //Mạng xã hội
        let arrSocialNetworkName = [];
        (item.social_networks || []).forEach(e => {
          arrSocialNetworkName.push(e.name);
        })
        item.social_network_name = arrSocialNetworkName.length > 0 ? `- ${arrSocialNetworkName.join(`\r\n- `)}` : "" ;
      });
      return MethodService.sortByName(dataFilterStatus, "administrative_info.name.first_name");
    },
    formatDate(value){
      return MethodService.formatDate(value,"date")
    },
    formatDateTableExcel(value){
      if (!value) return;
      let date;
      if (typeof value == "string") {
        date = new Date(MethodService.formatterMMDDYYYY(value));
      } else {
        date = value
      }
      return MethodService.formatDate(date,"date")
    },
    formatDateTableExcelError(value){
      if (!value) return;
      let date;
      if (typeof value == "string") {
        date = new Date(MethodService.formatterMMDDYYYY(value));
      } else {
        date = value
      }
      return MethodService.formatDate(date,"date")
    },
    async fn_uploadChangeFile(file, fileList) {
      const extension = file && file.name ? file.name.split(".").pop().toLowerCase() : "";
      if (!file || !file.raw || !["xls", "xlsx"].includes(extension)) {
        window.toastr.error("File phải có định dạng là .xlsx hoặc .xls");
        this.mData.fileUploadOption.File.fileList = [];
        return
      }
      await this.fn_readFileExcel(file);
      if (!this.mData.dataDefault.dataExcel.length) return;
      if (fileList.length > 1) {
        this.mData.fileUploadOption.File.fileList = [];
        this.mData.fileUploadOption.File.fileList.push(fileList[1]);
      } else {
        this.mData.fileUploadOption.File.fileList = fileList;
      }
      this.mData.dataDefault.file = file;
    },
  
    normalizeImportHeader(value) {
      return (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/\*/g, "")
        .replace(/\s+/g, " ");
    },
    parseImportDate(value) {
      if (!value) return null;
      if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
      const parsed = moment(value.toString().trim(), [
        "D/M/YYYY",
        "DD/MM/YYYY",
        "D-M-YYYY",
        "DD-MM-YYYY",
        "YYYY-MM-DD",
        moment.ISO_8601
      ], true);
      return parsed.isValid() ? parsed.toDate() : null;
    },
    importRowClassName({ rowIndex }) {
      return this.mData.importErrorRows.includes(rowIndex) ? "error-row_employee" : "";
    },
    async fn_readFileExcel(file) {
      this.clearDataErrorAndDataExcel();
      try {
        let rows = await MethodService.readExcel(file.raw, "Danh sách nhân sự");
        const aliases = {
          EmployeeNo: ["ma nhan vien", "ma nv"],
          FullName: ["ho va ten"],
          FirstName: ["ten"],
          LastName: ["ho va ten dem"],
          Gender: ["gioi tinh"],
          PhoneNumber: ["so dien thoai", "sdt"],
          Email: ["email", "email cong ty"],
          IdentifyCard: ["so cmnd", "so cccd/cmnd", "so cmnd/cccd"],
          Birthday: ["ngay sinh"],
          Address: ["dia chi"],
          Account: ["tai khoan dang nhap", "tai khoan (account)", "tai khoan"],
          ContractTypeCode: ["ma hop dong", "ten loai hd"],
          ContractTypeName: ["hop dong"],
          PositionCode: ["ma chuc vu", "ten chuc vu"],
          PositionName: ["chuc vu"],
          DepartmentCode: ["ma phong ban", "ten phong ban"],
          DepartmentName: ["phong ban"],
          BranchCode: ["ma chi nhanh", "ten chi nhanh"],
          BranchName: ["chi nhanh"],
          StartDate: ["ngay bat dau", "ngay vao lam"],
          EndDate: ["ngay ket thuc"]
        };
        const normalizedRows = rows.map(row => row.map(cell => this.normalizeImportHeader(cell)));
        const headerIndex = normalizedRows.findIndex(row =>
          row.includes("ma nhan vien") || row.includes("ma nv")
        );
        if (headerIndex < 0) {
          throw new Error("Không tìm thấy dòng tiêu đề có cột Mã nhân viên/Mã NV");
        }
        const header = normalizedRows[headerIndex];
        const columnMap = {};
        Object.keys(aliases).forEach(key => {
          columnMap[key] = header.findIndex(name => aliases[key].includes(name));
        });
        const valueAt = (row, key) => {
          const index = columnMap[key];
          const value = index >= 0 ? row[index] : null;
          return value instanceof Date ? value : (value === undefined || value === null ? null : value.toString().trim());
        };
        const dataRows = rows.slice(headerIndex + 1).filter(row => row.some(value => value !== null && value !== undefined && value !== ""));
        if (!dataRows.length) throw new Error("File không có dữ liệu nhân viên");
        if (dataRows.length > 1000) throw new Error("Mỗi lần chỉ được nhập tối đa 1.000 nhân viên");

        this.mData.dataDefault.dataExcel = dataRows.map(row => {
          let firstName = valueAt(row, "FirstName");
          let lastName = valueAt(row, "LastName");
          const fullName = valueAt(row, "FullName");
          if (fullName && (!firstName || !lastName)) {
            const parts = fullName.split(/\s+/);
            firstName = parts.pop() || "";
            lastName = parts.join(" ");
          }
          let account = valueAt(row, "Account");
          const companyName = this.mData.companyInfo && this.mData.companyInfo.name;
          const abbreviation = companyName && companyName.abbreviation_name ? companyName.abbreviation_name : "employee";
          const prefix = abbreviation.toLowerCase() + "_";
          if (account && !account.toLowerCase().startsWith(prefix)) account = prefix + account.toLowerCase();
          return {
            EmployeeNo: (valueAt(row, "EmployeeNo") || "").toUpperCase(),
            FirstName: firstName,
            LastName: lastName,
            Gender: valueAt(row, "Gender"),
            PhoneNumber: valueAt(row, "PhoneNumber"),
            Email: valueAt(row, "Email"),
            IdentifyCard: valueAt(row, "IdentifyCard"),
            Birthday: this.parseImportDate(valueAt(row, "Birthday")),
            Address: valueAt(row, "Address"),
            Account: account,
            ContractTypeCode: valueAt(row, "ContractTypeCode"),
            ContractTypeName: valueAt(row, "ContractTypeName"),
            PositionCode: valueAt(row, "PositionCode"),
            PositionName: valueAt(row, "PositionName"),
            DepartmentCode: valueAt(row, "DepartmentCode"),
            DepartmentName: valueAt(row, "DepartmentName"),
            BranchCode: valueAt(row, "BranchCode"),
            BranchName: valueAt(row, "BranchName"),
            StartDate: this.parseImportDate(valueAt(row, "StartDate")),
            EndDate: this.parseImportDate(valueAt(row, "EndDate")),
            messages: []
          };
        });

        const duplicateEmployeeNos = {};
        const duplicateAccounts = {};
        const addError = (rowIndex, field, value, message) => {
          this.mData.dataErrorFECheck.push({ field, value: value || "", message: `${message} tại dòng ${rowIndex + headerIndex + 2}` });
          if (!this.mData.importErrorRows.includes(rowIndex)) this.mData.importErrorRows.push(rowIndex);
        };
        this.mData.dataDefault.dataExcel.forEach((employee, rowIndex) => {
          [["EmployeeNo", "Mã nhân viên"], ["LastName", "Họ và tên đệm"], ["FirstName", "Tên"], ["Gender", "Giới tính"], ["Email", "Email"], ["Account", "Tài khoản"], ["ContractTypeCode", "Mã hợp đồng"]]
            .forEach(([key, label]) => { if (!employee[key]) addError(rowIndex, label, "", `${label} đang bị trống`); });
          if (employee.Email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(employee.Email)) addError(rowIndex, "Email", employee.Email, "Email sai định dạng");
          if (employee.PhoneNumber && !/^\+?[0-9]{8,15}$/.test(employee.PhoneNumber)) addError(rowIndex, "Số điện thoại", employee.PhoneNumber, "Số điện thoại sai định dạng");
          if (employee.EmployeeNo && (!/^[A-Z0-9]+$/.test(employee.EmployeeNo) || employee.EmployeeNo.length > 32)) addError(rowIndex, "Mã nhân viên", employee.EmployeeNo, "Mã nhân viên chỉ gồm A-Z và 0-9, tối đa 32 ký tự (ví dụ: UDS114)");
          const rawAccount = employee.Account ? employee.Account.substring(employee.Account.indexOf("_") + 1) : "";
          if (rawAccount && (!/^[a-zA-Z0-9.]+$/.test(rawAccount) || rawAccount.length < 4 || rawAccount.length > 50)) addError(rowIndex, "Tài khoản", rawAccount, "Tài khoản phải từ 4-50 ký tự và chỉ gồm chữ, số hoặc dấu chấm");
          const originalRow = dataRows[rowIndex];
          const originalStartDate = valueAt(originalRow, "StartDate");
          const originalEndDate = valueAt(originalRow, "EndDate");
          if (!originalStartDate) addError(rowIndex, "Ngày bắt đầu", "", "Ngày bắt đầu đang bị trống");
          else if (!employee.StartDate) addError(rowIndex, "Ngày bắt đầu", originalStartDate, "Ngày bắt đầu sai định dạng");
          if (originalEndDate && !employee.EndDate) addError(rowIndex, "Ngày kết thúc", originalEndDate, "Ngày kết thúc sai định dạng");
          if (employee.StartDate && employee.EndDate && moment(employee.StartDate).isAfter(moment(employee.EndDate))) addError(rowIndex, "Ngày kết thúc", employee.EndDate, "Ngày kết thúc phải sau ngày bắt đầu");
          if (employee.EmployeeNo) {
            if (!duplicateEmployeeNos[employee.EmployeeNo]) duplicateEmployeeNos[employee.EmployeeNo] = [];
            duplicateEmployeeNos[employee.EmployeeNo].push(rowIndex);
          }
          if (employee.Account) {
            const accountKey = employee.Account.toLowerCase();
            if (!duplicateAccounts[accountKey]) duplicateAccounts[accountKey] = [];
            duplicateAccounts[accountKey].push(rowIndex);
          }
        });
        [[duplicateEmployeeNos, "Mã nhân viên"], [duplicateAccounts, "Tài khoản"]].forEach(([groups, label]) => {
          Object.keys(groups).filter(key => groups[key].length > 1).forEach(key => {
            groups[key].forEach(rowIndex => addError(rowIndex, label, key, `${label} bị trùng trong file`));
          });
        });
        this.mData.haveErrorImport = this.mData.dataErrorFECheck.length > 0;
        this.visibleDialogValidateImport = this.mData.haveErrorImport;
      } catch (error) {
        this.mData.fileUploadOption.File.fileList = [];
        window.toastr.error(error.message || "Không thể đọc file Excel");
      }
    },
    async fn_readFileExcelLegacy(file){
      try {
        this.clearDataErrorAndDataExcel();
        let valueFile = await MethodService.readExcel(file.raw);
        this.mData.dataDefault.dataExcelBody = valueFile.splice(1,valueFile.length);
        this.mData.dataDefault.dataExcelBody.forEach(item => {
          let obj = {};
          item.forEach((e,i) =>{
            obj[this.mData.dataDefault.dataExcelHeader[i]] = e ? (e instanceof Date ? e : e.toString().trim()) : null;
            obj.messages = []
          });
          this.mData.dataDefault.dataExcel.push(obj);
        })
        this.mData.dataDefault.dataExcel.forEach(e => {
          if (e.EmployeeNo) {
            e.EmployeeNo = e.EmployeeNo.toString().toUpperCase();
          }
          if (e.Account) {
            e.Account = this.mData.companyInfo.name.abbreviation_name.toLowerCase() + "_" + e.Account.toLowerCase();
          }
          if (e.StartDate) {
            if (typeof e.StartDate == "string") {
              let date = new Date(MethodService.formatterMMDDYYYY(e.StartDate));
              e.StartDate = date;
            }
          }
          if (e.EndDate) {
            if (typeof e.EndDate == "string") {
              let date = new Date(MethodService.formatterMMDDYYYY(e.EndDate));
              e.EndDate = date;
            }
          }
        })
        setTimeout(() =>{
          this.dialogVisible = true;
          let objDulicateEmNo = {};
          let objDulicateAccount = {};
          let error = false;
          this.mData.dataDefault.dataExcelBody.forEach((item,index) => {
            if (item[0]) {
              item[0] = item[0].toString().toUpperCase();
            }
            document.getElementsByTagName("tbody")[0].children[index].classList.remove("error-row_employee");
            if(!item[0] || !item[1] || !item[2] || !item[3] || !item[5] || !item[9] || !item[10] || !item[18]){
              error = true;
              let messageErrorNull = {};
              messageErrorNull['field'] = !item[0] ? "Mã nhân viên" :
                !item[1] ? "Họ và tên đệm" :
                !item[2] ? "Tên" :
                !item[3] ? "Giới tính" :
                !item[5] ? "Email" :
                !item[9] ? "Tài khoản" :
                !item[10] ? "Mã hợp đồng" :
                !item[18] ? "Ngày bắt đầu" :
                "Dữ liệu trống";
              messageErrorNull['value'] = "";
              messageErrorNull['message'] = `${
                !item[0] ? "Mã nhân viên" :
                !item[1] ? "Họ và tên đệm" :
                !item[2] ? "Tên" :
                !item[3] ? "Giới tính" :
                !item[5] ? "Email" :
                !item[9] ? "Tài khoản" :
                !item[10] ? "Mã hợp đồng" :
                !item[18] ? "Ngày bắt đầu" :
                "Dữ liệu"
              } đang bị trống tại dòng thứ ${index + 1}`;
              this.mData.dataErrorFECheck.push(messageErrorNull);
              document.getElementsByTagName("tbody")[0].children[index].classList.add("error-row_employee");
            }
            let regexSpaceCenter = /^\S+$/;
            if (
              item[0] &&
              !/^[A-Z0-9]+$/.test(item[0])
            ) {
              let messageErrorInvalidEmployeeNo = {};
              messageErrorInvalidEmployeeNo['field'] = "Mã nhân viên";
              messageErrorInvalidEmployeeNo['value'] = item[0];
              messageErrorInvalidEmployeeNo['message'] = `Mã nhân viên tại dòng thứ ${index + 1} chỉ gồm A-Z và 0-9, không chứa khoảng trắng hoặc ký tự đặc biệt (ví dụ: UDS114)`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidEmployeeNo);
            }
            if (
              item[4] &&
              !regexSpaceCenter.test(item[4])
            ) {
              let messageErrorInvalidPhone = {};
              messageErrorInvalidPhone['field'] = "Số điện thoại";
              messageErrorInvalidPhone['value'] = item[4];
              messageErrorInvalidPhone['message'] = `Số điện thoại tại dòng thứ ${index + 1} không được nhập khoảng trắng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidPhone);
            }
            if (
              item[9] &&
              !regexSpaceCenter.test(item[9])
            ) {
              let messageErrorInvalidAccountSpace = {};
              messageErrorInvalidAccountSpace['field'] = "Tài khoản";
              messageErrorInvalidAccountSpace['value'] = item[9];
              messageErrorInvalidAccountSpace['message'] = `Tài khoản tại dòng thứ ${index + 1} không được nhập khoảng trắng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidAccountSpace);
            }
            if (
              item[4] &&
              isNaN(parseInt(item[4]))
            ) {
              let messageErrorInvalidPhonenumber = {};
              messageErrorInvalidPhonenumber['field'] = "Số điện thoại";
              messageErrorInvalidPhonenumber['value'] = item[4];
              messageErrorInvalidPhonenumber['message'] = `Số điện thoại tại dòng thứ ${index + 1} sai định dạng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidPhonenumber);
            }
            let mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (
              item[5] &&
              !mailRegex.test(item[5])
            ) {
              let messageErrorInvalidMail = {};
              messageErrorInvalidMail['field'] = "Email";
              messageErrorInvalidMail['value'] = item[5];
              messageErrorInvalidMail['message'] = `Email tại dòng thứ ${index + 1} sai định dạng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidMail);
            }
            if (item[2] &&
              item[2].toString().length > 15) {
              let messageErrorNameLength= {};
              messageErrorNameLength['field'] = "Tên";
              messageErrorNameLength['value'] = item[2];
              messageErrorNameLength['message'] = `Tên tại dòng thứ ${index + 1} không nhập quá 15 ký tự`;
              this.mData.dataErrorFECheck.push(messageErrorNameLength);
            }
            if (item[0] &&
              item[0].toString().length > 32) {
              let messageErrorNameLength= {};
              messageErrorNameLength['field'] = "Mã nhân viên";
              messageErrorNameLength['value'] = item[0];
              messageErrorNameLength['message'] = `Mã nhân viên tại dòng thứ ${index + 1} không nhập quá 32 ký tự`;
              this.mData.dataErrorFECheck.push(messageErrorNameLength);
            }
            if (
              item[9] &&
              (item[9].toString().length < 4 || item[9].toString().length > 12)
            ) {
              let messageErrorInvalidAccount= {};
              messageErrorInvalidAccount['field'] = "Tải khoản";
              messageErrorInvalidAccount['value'] = item[9];
              messageErrorInvalidAccount['message'] = `Tài khoản tại dòng thứ ${index + 1} phải lớn hơn 4 ký tự và nhỏ hơn 12 ký tự`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidAccount);
            }
            // eslint-disable-next-line no-useless-escape
            let accountRegex = /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/g;
            if (
              item[9] &&
              !accountRegex.test(item[6])
            ) {
              let messageErrorInvalidAccount= {};
              messageErrorInvalidAccount['field'] = "Tải khoản";
              messageErrorInvalidAccount['value'] = item[9];
              messageErrorInvalidAccount['message'] = `Tài khoản tại dòng thứ ${index + 1} không được nhập ký tự đặc biệt`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidAccount);
            }
            if (item[18] && (!moment(moment(item[18]).toISOString()).isValid() || this.formatDate(item[18]) == "Invalid date")) {
              let messageErrorInvalidStartDate = {};
              messageErrorInvalidStartDate['field'] = "Ngày bắt đầu";
              messageErrorInvalidStartDate['value'] = item[18];
              messageErrorInvalidStartDate['message'] = `Ngày bắt đầu tại dòng thứ ${index + 1} sai định dạng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidStartDate);
            }
            if (item[19] && (!moment(moment(item[19]).toISOString()).isValid() || this.formatDate(item[19]) == "Invalid date")) {
              let messageErrorInvalidEndDate = {};
              messageErrorInvalidEndDate['field'] = "Ngày kết thúc";
              messageErrorInvalidEndDate['value'] = item[19];
              messageErrorInvalidEndDate['message'] = `Ngày kết thúc tại dòng thứ ${index + 1} sai định dạng`;
              this.mData.dataErrorFECheck.push(messageErrorInvalidEndDate);
            }
            if (
              (item[18] && (moment(moment(item[18]).toISOString()).isValid() || this.formatDate(item[18]) != "Invalid date")) &&
              (item[19] && (moment(moment(item[19]).toISOString()).isValid() || this.formatDate(item[19]) != "Invalid date"))
            ) {
              if (new Date(item[18]).getTime() > new Date(item[19]).getTime()) {
                let messageErrorStartDateAndEndDate = {};
                messageErrorStartDateAndEndDate['field'] = "Ngày kết thúc";
                messageErrorStartDateAndEndDate['value'] = this.formatDate(item[18]) + " - " +this.formatDate(item[19]);
                messageErrorStartDateAndEndDate['message'] = `Ngày kết thúc tại dòng thứ ${index + 1} phải lớn hơn ngày bắt đầu`;
                this.mData.dataErrorFECheck.push(messageErrorStartDateAndEndDate);
              }
            }
            if (item[0] != undefined) {
              if(!(item[0] in objDulicateEmNo)){
                objDulicateEmNo[item[0]] = [];
                objDulicateEmNo[item[0]].push(index);
              } else {
                objDulicateEmNo[item[0]].push(index);
              }
            }
            if (item[9] != undefined) {
              if(!(item[9] in objDulicateAccount)){
                objDulicateAccount[item[9]] = [];
                objDulicateAccount[item[9]].push(index);
              } else {
                objDulicateAccount[item[9]].push(index);
              }
            }
          });
          for (const [key, value] of Object.entries(objDulicateEmNo)) {
            if(value.length > 1){
              value.forEach(e => {
                error = true;
                document.getElementsByTagName("tbody")[0].children[e].classList.add("error-row_employee");
              })
              let messageError = {};
              messageError['field'] = "Mã nhân viên";
              messageError['value'] = key;
              messageError['message'] = `Mã nhân viên "${key}" đang bị trùng tại dòng thứ ${value.map(x => x + 1).join(", ")}`;
              this.mData.dataErrorFECheck.push(messageError);
            }
          }
          for (const [key, value] of Object.entries(objDulicateAccount)) {
            if(value.length > 1){
              value.forEach(e => {
                error = true;
                document.getElementsByTagName("tbody")[0].children[e].classList.add("error-row_employee");
              })
              let messageError = {};
              messageError['field'] = "Tài khoản";
              messageError['value'] = key;
              messageError['message'] = `Tài khoản "${key}" đang bị trùng tại dòng thứ ${value.map(x => x + 1).join(", ")}`;
              this.mData.dataErrorFECheck.push(messageError) ;
            }
          }
          if (error && this.mData.dataErrorFECheck.length > 0) {
            this.mData.haveErrorImport = true;
            this.visibleDialogValidateImport = true;
          } else {
            this.mData.haveErrorImport = false;
          }
        }, 500);
      } catch (error) {
        console.log("error",error);
      }
    },
    clearDataErrorAndDataExcel(){
      this.mData.dataDefault.dataExcel = [];
      this.mData.dataErrorFECheck = [];
      this.mData.dataDefault.dataExcelBody = [];
      this.mData.importErrorRows = [];
      this.mData.dataDefault.dataExcelHeader = ["EmployeeNo", "LastName", "FirstName", "Gender", "PhoneNumber", "Email", "IdentifyCard", "Birthday", "Address", "Account",
                                                  "ContractTypeCode", "ContractTypeName", "PositionCode", "PositionName", "DepartmentCode", "DepartmentName", "BranchCode", "BranchName", "StartDate", "EndDate"];
    },
    closeImport(){
      this.mData.dialogFormImportNhanVien = false
      setTimeout(() => {
        this.mData.dataDefault.dataExcel = [];
        this.mData.fileUploadOption.File.fileList = [];
        this.mData.dataErrorFECheck = [];
        this.mData.dataDefault.file = undefined;
        this.mData.haveErrorImport = false;
      }, 100);
    },
    async importEmployee(){
      if (this.mData.importing || this.mData.haveErrorImport || !this.mData.dataDefault.dataExcel.length) return;
      this.mData.importing = true;
      try {
        const importEmployee = await EmployeeApi.ImportExcelEmployee(this.mData.dataDefault.dataExcel);
        if (importEmployee && importEmployee.result && importEmployee.result.successCount == 0) {
          window.toastr.error("Nhập dữ liệu nhân viên thất bại");
        } else {
          window.toastr.success("Nhập dữ liệu nhân viên thành công");
        }
        this.clearDataErrorAndDataExcel();
        this.closeImport();
        if (importEmployee.result.lstErrors && importEmployee.result.lstErrors.length > 0) {
          this.mData.dataDefault.listErrorImport = importEmployee.result.lstErrors;
          this.mData.dataDefault.listErrorImport.forEach(e => {
            if (e.StartDate) {
              let date = new Date(e.StartDate);
              e.StartDate = date;
            }
            if (e.EndDate) {
              let date = new Date(e.EndDate);
              e.EndDate = date;
            }
          })
          setTimeout(async () => {
            this.mData.haveErrorImport = true;
            this.dialogErrorImportNhanVienBE = true;
            await this.fn_innitDataDefault("download");
            await MethodService.exportTemplateImportEmployee(this.mData.dataDefault.listErrorImport,this.mData.dataDefault.listChiNhanh,this.mData.dataDefault.listPhongBan,this.mData.dataDefault.listChucVu,this.mData.dataDefault.listHopDong,'error');
          }, 500);
        }
        this.fn_initTable();
      } catch (error) {
        console.log("error",error);
        window.toastr.error("Nhập dữ liệu nhân viên thất bại. Vui lòng thử lại");
      } finally {
        this.mData.importing = false;
      }
    },
    closeErrorImportNhanVienBE(){
      this.mData.dataDefault.listErrorImport = [];
      this.mData.haveErrorImport = false;
      this.dialogErrorImportNhanVienBE = false;
    },
    fn_hashUrl() {
      if (this.$route.query.from) {
        this.mData.tableRules = EmployeeModel.tableRulesDefault;
        return
      }
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        let m1 = !this.$route.query.condition && this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(this.mData.tableRules.dataSearch.value, 'condition', decodeURIComponent(m1[1]));
        }
      }
      if (this.$route.query.view) {
        this.currentView = this.$route.query.view;
      }
      if (this.$route.query.constractValidity) {
        this.mData.tableRules.dataSearch.value['start_date*end_date'] = this.$route.query.constractValidity
      }
      if (this.$route.query.seniority) {
        this.mData.tableRules.dataSearch.value['start_work_date'] = this.$route.query.seniority
      }
      if (this.$route.query.condition) {
        this.mData.tableRules.dataSearch.value.condition = this.$route.query.condition
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  },
  async created() {
    await this.fn_hashUrl();
    this.fn_initTable();
    this.fn_innitDataDefault().catch((error) => {
      console.log("error init employee default data", error);
    });
  },
  computed: {
    noMore () {
      return this.mData.tableRules.limit >= this.mData.tableRules.total
    },
    disabled () {
      return this.loading || this.noMore
    }
  }
};
</script>

<style lang="scss" scoped>
.full_name{
  font-weight: 600;
}
.full_name:hover{
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
}
.main-body-search{
  padding-right: 10px;
}
/* .main-body-table{
  border-radius: 12px;
} */
.main-body-list{
  background: var(--white);
  border-radius: 12px;
  padding: 30px 30px;
  overflow: auto;
  box-shadow: 10px 3px 15px rgba(0, 0, 0, 0.05);
}
.e-avatar{
  width: 130px;
  height: 130px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  border: 2px solid var(--orange);
}
.e-avatar .el-image{
  border-radius: 50%;
}
::v-deep .el-card__body{
  padding-top: 70px;
  position: relative;
}
.employee{
  margin-bottom: 19px;
}
.employee .e-name{
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 25px;
  text-align: center;
  color: var(--orange);
}
.detail-infomation{
  padding-left: 15px;
}
.detail-infomation p {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.e-name, .e-position, .detail-infomation p span{
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detail-infomation p i{
  color: var(--orange);
  margin-right: 15px;
}
::v-deep .row-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  /* margin-bottom: 18px; */
}
.flex-width{
  flex: 1 0 calc((100% - 30px)/3);
  max-width: calc((100% - 30px)/3);
  margin-bottom: 18px;
}
.input-condition{
  flex-grow: 1;
}
.btn-search{
  margin-left: 20px;
  width: 120px;
  display: flex;
  justify-content: center;
}
::v-deep .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  margin-bottom: 0;
}
::v-deep .box-card{
  margin: 0 10px;
  margin-bottom: 40px;
  margin-top: 65px;
}
::v-deep .el-upload-dragger {
  height: 130px;
}
::v-deep .el-upload-dragger .el-icon-upload {
  font-size: 40px;
  margin: 25px 0 0px;
  line-height: 30px;
}
::v-deep .link-file {
  color: #0c66ad !important;
  font-weight: bold;
  text-decoration: underline !important;
}
::v-deep .link-file:hover {
  color: #06ace9 !important;
  font-weight: bold;
  text-decoration: none !important;
}
::v-deep .el-table__body-wrapper {
  /* max-height: calc(100vh - 300px); */
  overflow-y: auto;
  width: 100%;
}
::v-deep .el-table.table-error-message {
  tbody tr {
    .cell {
      white-space: unset;
    }
  }
}
.el-button__handle{
  float: left;
  font-size: 13px;
  width: 90px;
  height: 30px;
  display: flex;
  align-items: center;
}
.el-button__handle:hover {
  cursor: pointer;
}
.handle-action .status {
  float: right;
  width: 120px;
  height: 30px;
  border-radius: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.handle-action .status span{
  color: var(--white);
  border-radius: 84px;
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
}
.handle-action:after{
  clear: both;
  content: ".";
  display: block;
  width: 0px;
  height: 0px;
}
.work{
  background: var(--green);
}
.off-work{
  background: var(--red);
}
.card-body{
  padding: 0;
}
::v-deep .hide .el-upload{
  display: none;
}
::v-deep .el-upload-list{
  text-align: center;
}
::v-deep .import__employee .el-dialog{
  max-height: calc(100vh - 80px);
}
::v-deep .error-row{
    background-color: #ffd7d7 !important;
}
::v-deep .error-row:hover{
    background-color: #ffd7d7 !important;
}
::v-deep .error-row_employee{
    background-color: #ffd7d7 !important;
}
::v-deep .error-row_employee:hover{
    background-color: #ffd7d7 !important;
}
.customs {
  display: flex;
}
.fas.fa-th,
.fas.fa-list {
  font-size: 25px;
  color: var(--orange);
}

@media (max-width: 1568px) and (min-width: 1200px) {
  ::v-deep .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9,
  .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2,
  .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9,
  .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2,
  .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9,
  .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1,
  .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7,
  .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12,
  .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1{
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 1440px) and (min-width: 1200px) {
  ::v-deep .el-card__body{
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media (max-width: 1370px) {
  .main-body{
    padding-left: 0;
    padding-right: 0;
  }
  .handle-action .status{
    width: 100px;
  }
  .handle-action .status span{
    font-size: 12px;
  }
}
@media (max-width: 860px){
  .body-header{
    flex-direction: column;
  }
}
@media (max-width: 750px){
  .flex-width{
    -webkit-box-flex: 1;
    flex: 1 0 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }
  .row-flex{
    margin-bottom: 0;
  }
  .main-body-list{
    margin-top: 15px;
  }
}
@media (max-width: 550px){
  .button__search{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
}
</style>
<style lang="scss" scoped>
.icon-haveDraff {
  position: absolute;
  top: 10px;
  right: 15px;
  .fas {
    &::before {
      font-size: 30px;
      color: var(--orange);
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.switch-view {
  display: inline-block;
  margin-left: 10px;
  .list__view {
    display: flex;
    background: var(--white);
    box-shadow: 0px 0px 20px rgb(43 43 43 / 13%);
    height: 45px;
    width: 100px;
    border-radius: 10px;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    .view {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
      border-radius: 10px;
      width: 40px;
      height: 35px;
      text-align: center;
      &:hover{
        cursor: pointer;
      }
      &.active-view {
        background: var(--orange);
        .fas.fa-th,
        .fas.fa-list {
          color: var(--white);
        }
      }
    }
  }
}
@media (max-width: 860px) {
  .employee-list .body-header { gap: 12px; }
  .employee-actions { width: 100%; min-width: 0; }
  .employee-actions .customs { display: flex; flex-wrap: wrap; gap: 8px; width: 100%; justify-content: flex-start; }
  .employee-actions .el-button, .employee-actions .switch-view { margin: 0; }
}
</style>
